import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const ChangePlanRequestComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="契約内容変更完了" content="契約内容の変更が完了しました。"isFacility={false}  />
      </Layout>
    </React.Fragment>
  )
}

export default ChangePlanRequestComplete;